var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDownloadSpeed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.4706 2 22 6.52941 22 12C22 17.4608 17.4608 22 11.9902 22C6.52941 22 2 17.4608 2 12C2 6.52941 6.53922 2 12 2ZM12 3.66667C7.37255 3.66667 3.67647 7.37255 3.67647 12C3.67647 16.6176 7.36275 20.3333 11.9902 20.3333C16.6176 20.3333 20.3235 16.6176 20.3333 12C20.3431 7.37255 16.6275 3.66667 12 3.66667ZM12 17.0392C11.7941 17.0392 11.6275 16.9608 11.4314 16.7647L8.10784 13.451C7.97059 13.3235 7.91177 13.1471 7.91177 12.9412C7.91177 12.5392 8.21569 12.2353 8.61765 12.2353C8.83333 12.2353 9.0098 12.3137 9.13726 12.451L10.3627 13.6765L11.3431 14.8529L11.2647 12.7843V7.67647C11.2647 7.2451 11.5784 6.94118 12 6.94118C12.4314 6.94118 12.7353 7.2451 12.7353 7.67647V12.7843L12.6569 14.8627L13.6569 13.6765L14.8627 12.451C14.9902 12.3039 15.1765 12.2353 15.3824 12.2353C15.7843 12.2353 16.098 12.5392 16.098 12.9412C16.098 13.1471 16.0294 13.3235 15.902 13.451L12.5784 16.7647C12.3922 16.951 12.2157 17.0392 12 17.0392Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDownloadSpeed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-download-speed.29096d5047223c571cb691dcb0123a5e.svg";